export const movies = [
    {
        title: 'Harry Potter',
        poster: 'https://m.media-amazon.com/images/M/MV5BMGVmMWNiMDktYjQ0Mi00MWIxLTk0N2UtN2ZlYTdkN2IzNDNlXkEyXkFqcGdeQXVyODE5NzE3OTE@._V1_SX300.jpg',
        duration: '2h 22m'
    },
    {
        title: 'The Lord of the Rings',
        poster: 'https://image.tmdb.org/t/p/w500/6oom5QYQ2yQTMJIbnvbkBL9cHo6.jpg',
        duration: '2h 58m'
    },
    {
        title: 'Inception',
        poster: 'https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_SX300.jpg',
        duration: '2h 28m'
    },
    {
        title: 'The Dark Knight',
        poster: 'https://image.tmdb.org/t/p/w500/qJ2tW6WMUDux911r6m7haRef0WH.jpg',
        duration: '2h 32m'
    },
    {
        title: 'Forrest Gump',
        poster: 'https://image.tmdb.org/t/p/w500/h5J4W4veyxMXDMjeNxZI46TsHOb.jpg',
        duration: '2h 22m'
    },
    {
        title: 'The Matrix',
        poster: 'https://image.tmdb.org/t/p/w500/f89U3ADr1oiB1s9GkdPOEpXUk5H.jpg',
        duration: '2h 16m'
    },
    {
        title: 'The Shawshank Redemption',
        poster: 'https://image.tmdb.org/t/p/w500/q6y0Go1tsGEsmtFryDOJo3dEmqu.jpg',
        duration: '2h 22m'
    },
    {
        title: 'Pulp Fiction',
        poster: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUXakDRVpAC3ahXaLSM1_DwSIcGu66vZdIBA&s',
        duration: '2h 34m'
    },
    {
        title: 'The Godfather',
        poster: 'https://image.tmdb.org/t/p/w500/3bhkrj58Vtu7enYsRolD1fZdja1.jpg',
        duration: '2h 55m'
    },
    {
        title: 'Fight Club',
        poster: 'https://image.tmdb.org/t/p/w500/bptfVGEQuv6vDTIMVCHjJ9Dz8PX.jpg',
        duration: '2h 19m'
    },
    {
        title: 'Interstellar',
        poster: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWjv5BApf_xYqfSx95bUMYRRlHPPmq5nuZ4Q&s",
        duration: '2h 49m'
    },
    {
        title: 'Gladiator',
        poster: 'https://image.tmdb.org/t/p/w500/ty8TGRuvJLPUmAR1H1nRIsgwvim.jpg',
        duration: '2h 35m'
    },
    {
        title: 'Saving Private Ryan',
        poster: 'https://image.tmdb.org/t/p/w500/1wY4psJ5NVEhCuOYROwLH2XExM2.jpg',
        duration: '2h 49m'
    },
    {
        title: 'Schindler\'s List',
        poster: 'https://image.tmdb.org/t/p/w500/sF1U4EUQS8YHUYjNl3pMGNIQyr0.jpg',
        duration: '3h 15m'
    },
    {
        title: 'Avengers: Endgame',
        poster: 'https://image.tmdb.org/t/p/w500/or06FN3Dka5tukK1e9sl16pB3iy.jpg',
        duration: '3h 1m'
    },
    {
        title: 'The Lion King',
        poster: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfgXz1NdzVoPk1IYnZDzjXz5DvF9oRSZeQ2g&s',
        duration: '1h 29m'
    },
    {
        title: 'Jurassic Park',
        poster: 'https://image.tmdb.org/t/p/w500/oU7Oq2kFAAlGqbU4VoAE36g4hoI.jpg',
        duration: '2h 7m'
    },
    {
        title: 'The Silence of the Lambs',
        poster: 'https://image.tmdb.org/t/p/w500/rplLJ2hPcOQmkFhTqUte0MkEaO2.jpg',
        duration: '1h 58m'
    },
    {
        title: 'Star Wars: A New Hope',
        poster: 'https://image.tmdb.org/t/p/w500/6FfCtAuVAW8XJjZ7eWeLibRLWTw.jpg',
        duration: '2h 1m'
    },
    {
        title: 'Back to the Future',
        poster: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7wmAPDCp5daAf331wUwabTchKFzFSdBbFOA&s',
        duration: '1h 56m'
    }
];
